<template>
    <div :class="opt.type == 'radio' ? 'inputgroup horizontal' : (opt.type == 'checkbox' ? 'inputgroup horizontal checkbox' : 'inputgroup')">
        <strong v-if="opt.title == 'Whole pounds expected only'">£</strong>
        <label v-if="opt.class == 'addinps'" :for='id' class="addlabs">{{text}}</label>
        <template v-if="opt.type == 'radio' || opt.type == 'checkbox'">
            <input
            :id='id' v-bind='opt' @focusout="addTouch()" @click="opt.type == 'radio' ? (removeRadioValidation(id), 
   id.indexOf('AdditionalIncomeIndicator') !== -1 || id.indexOf('CreditType') !== -1 ? emitRed() : '') : '', addCheckedAtt()"
            :class="(id.indexOf('Name') !== -1) ? 'nameinps' : opt.class"
            :autocomplete="(id.indexOf('Name') !== -1) ? 'no' : opt.autocomplete"
            />
            <label
                v-if="opt.class !== 'addinps'" :id='id + "Label"' :for='id' :tabindex="!opt.title && opt.labelTabIndexZero ? '0' : false"
                @keypress.enter.prevent="$event.target.click"
                @click="id.indexOf('AdditionalIncomeIndicator') !== -1 || id.indexOf('CreditType') !== -1 ? emitRed() : ''">{{text}}</label>
        </template>
        <template v-else>
            <label
                v-if="opt.class !== 'addinps'" :id='id + "Label"' :for='id' :tabindex="!opt.title && opt.labelTabIndexZero ? '0' : false"
                @keypress.enter.prevent="$event.target.click"
                @click="id.indexOf('AdditionalIncomeIndicator') !== -1 || id.indexOf('CreditType') !== -1 ? emitRed() : ''">{{text}}</label>
            <span v-if="opt.additionalInfo" class="additional-info">{{ opt.additionalInfo }}</span>
            <template v-if="prefix">
                <span :class="errors[id] && !isDateItem ? 'form-error js-form-error' : 'form-error hidden js-form-error'" :id='id + "Error"' aria-live="assertive">{{ errors[id] }}</span>
                <div :class="this.focused ? 'prefix-wrap focused' : 'prefix-wrap'">
                    <div :class="this.complete ? 'prefix complete' : 'prefix'">
                        <span>{{prefix}}</span>
                    </div>
                    <input
                    :id='id' v-bind='opt' v-model="localValue" @keyup="validateItem()" @focus="focused = true" :aria-invalid="invalid" @focusin="focused = true" @focusout="addTouch(), validateItem(), focused = false"
                    :class="{
                      nameinps: id.indexOf('Name') !== -1,
                      touched: touched,
                      invalid: invalid,
                      complete: complete,
                      [opt.class]: id.indexOf('Name') === -1
                    }"
                    :autocomplete="opt.autocomplete"
                    />
                </div>
            </template>
            <template v-else>
                <span :class="errors[id] && !isDateItem ? 'form-error js-form-error' : 'form-error hidden js-form-error'" :id='id + "Error"' aria-live="assertive">{{ errors[id] }}</span>
                <input
                :id='id' v-bind='opt' v-model="localValue" :aria-invalid="invalid" @input="limitLength(localValue)" :maxlength="id == 'houseName' || id == 'houseNameManual' || id == 'flatNumber' || id == 'houseNumber' ? 32 : id == 'postCodeAuto' || id == 'postCode' ? 8 : null" @keyup="validateItem()" @focusout="addTouch(), validateItem()"
                :class="{
                  nameinps: id.indexOf('Name') !== -1,
                  touched: touched,
                  invalid: invalid,
                  complete: complete,
                  [opt.class]: id.indexOf('Name') === -1
                }"
                :autocomplete="opt.autocomplete"
                />
            </template>
        </template>
    </div>
</template>

<script>
/*eslint-disable */
export default {
    name: 'inputGroup',
    props: {
        id: String,
        text: String,
        opt: Object,
        prefix: String,
        mandatoryMessage: String,
        invalidMessage: String,
        maxLength: Number,
        minLength: Number,
        isDateItem: Boolean,
        addressValue: String,
        externalErrors: Object, //errors passed in from validateAddress function
        addressFieldValidations: Object
    },
    data() {
        return {
            localValue: this.addressValue || '',
            errors: {},
            touched: false,
            complete: false,
            focused: false,
            invalid: false
        }
    },
    computed: {
      inputValue: {
        get() {
          if(this.addressValue) {
            return this.addressValue;
          } else {
            return this.value;
          }
        }
      }
    },
    watch: {
      externalErrors: {
        deep: true,
        handler(newErrors) {
          this.errors = newErrors || {};
        }
      },
      externalTouched(newTouched) {
        this.touched = newTouched; // if errors passed from validateAddress
      }
    },
    methods: {
        addBlock: function(a) {
            var blockclasses = ["radio", "radio checktitle", "dateinps", "addinps"];
            for (var i = 0; i < blockclasses.length; i++) {
                if (a == blockclasses[i]) {return true;}
            }
        },
        removeRadioValidation(element) {
          var parent = document.getElementById(element).parentElement.parentElement.parentElement;
          var formError = parent.querySelector('.js-form-error');
          formError.classList.add('hidden');
        },
        removeErr: function(a) {
            var parelem = getById(a).parentElement.parentElement;
            // PST-567 prevent issues with privacy policy text being removed as part of 'error' handling
            if (parelem.parentElement && parelem.parentElement.id && parelem.parentElement.id === 'permissions') {
                return;
            }
            parelem.classList.remove('problem');

            // Iterate through all <p> elements and remove only those that do not have the class 'no-remove'
            var pElements = parelem.getElementsByTagName('p');
            for (let i = 0; i < pElements.length; i++) {
                if (!pElements[i].classList.contains('no-remove')) {
                    removeElem(pElements[i]);
                }
            }
        },
        addCheckedAtt: function(a) {
            var inputSets = document.getElementsByTagName('fieldset');
            for (var i = 0; i < inputSets.length; i++) {
                var inputElms = inputSets[i].getElementsByTagName('input');
                for (var n = 0; n < inputElms.length; n++) {
                    if ((!inputElms[n].checked) && (inputElms[n].hasAttribute("checked"))){
                        document.getElementById(inputElms[n].id).removeAttribute("checked");
                    }
                    if (inputElms[n].checked) {
                        inputElms[n].setAttribute("checked", "")
                    }
                }
            }
            
            if(this.id == "noUkResidencyCode") {
              this.$emit('updateUkResident', true);
            }

            if(this.id == "yesUkResidencyCode") {
              this.$emit('updateUkResident', false);
            }

        },
        emitRed: function() {
            this.$emit('togreduce');
        },
        addTouch() {
          this.touched = true;
        },
        limitLength(thisValue) {
          var maxCharacters = {
            birthDateDay: 2,
            birthDateMonth: 2,
            currentMovedInMonth: 2,
            birthDateYear: 4,
            currentMovedInYear: 4
          }

          if(maxCharacters.hasOwnProperty(this.id)) {
            this.localValue = thisValue.slice(0, maxCharacters[this.id]);
          }
        },
        validateItem() {
          var value = this.localValue;
          var mandatoryMessage = this.mandatoryMessage;
          var minLength = this.minLength;
          var maxLength = this.maxLength;

          // Check if the current id has validations in addressFieldValidations
          if (this.addressFieldValidations && this.addressFieldValidations[this.id]) {
            var fieldValidation = this.addressFieldValidations[this.id];
            if (fieldValidation.optional === false) {
              minLength = fieldValidation.min;
              maxLength = fieldValidation.max;
              mandatoryMessage = `Please enter a ${fieldValidation.name}`;
            }
          }

          // one of flat number, house name or house number
          if(getById("flatNumber") && getById("houseNameManual") && getById("houseNumber")) {
            if (getById("flatNumber").value.trim() != "" || getById("houseNameManual").value.trim() != "" || getById("houseNumber").value.trim() != "" ) {
              if(this.errors.hasOwnProperty("noneOfThree")) {
                this.$delete(this.externalErrors, "noneOfThree");
              }
            }
          }

          if(this.touched || this.errors.hasOwnProperty(this.id)) {

            //if mandatory input is empty, except for the date inputs as these will be treated as one further down
            if(mandatoryMessage && value == "" && !this.isDateItem) {
              this.$set(this.errors, this.id, mandatoryMessage);
              this.complete = false;
              this.invalid = true;
              this.$emit('update-errors', this.errors);
              formIsInvalid = true;
              return;
            } else {
              this.invalid = false;
              this.$delete(this.errors, this.id);
              this.$emit('update-errors', this.errors);
            }

            //if input has too many characters
            if(maxLength && value.length > maxLength) {
              this.$set(this.errors, this.id, mandatoryMessage + ' of ' + maxLength + ' characters or less');
              this.complete = false;
              this.invalid = true;
              this.$emit('update-errors', this.errors);
              formIsInvalid = true;
              return;
            } else {
              this.invalid = false;
            }

            //if input has too few characters
            if(minLength && value.length < minLength) {
              this.$set(this.errors, this.id, mandatoryMessage + ' of ' + minLength + ' or more characters');
              this.complete = false;
              this.invalid = true;
              this.$emit('update-errors', this.errors);
              formIsInvalid = true;
              return;
            } else {
              this.invalid = false;
            }

            switch (this.id) {
              case "firstName":
              case "lastName":
                var nameRegEx = new RegExp("^[a-zA-Z '-]*$") //letters, spaces, apostrophes and dashes
                if(!value.match(nameRegEx)) {
                  this.$set(this.errors, this.id, this.invalidMessage);
                  this.complete = false;
                  this.invalid = true;
                  this.$emit('update-errors', this.errors);
                  formIsInvalid = true;
                  return;
                } else {
                  this.invalid = false;
                }
                break;

              case "emailAddress":
                if(!value.match(new RegExp(("\^\(\[a\-zA\-Z0\-9_\\\-\\\.\]\+\)@\(\(\\\[\[0\-9\]\{1,3\}\\\.\[0\-9\]\{1,3\}\\\.\[0\-9\]\{1,3\}\\\.\)\|\(\(\[a\-zA\-Z0\-9\\\-\]\+\\\.\)\+\)\)\(\[a\-zA\-Z\]\{2,4\}\|\[0\-9\]\{1,3\}\)\(\\\]\?\)\$"), "i"))) {
                    this.$set(this.errors, this.id, this.invalidMessage);
                    this.complete = false;
                    this.invalid = true;
                    this.$emit('update-errors', this.errors);
                    formIsInvalid = true;
                    return;
                }
                break;

              case "birthDateDay":
              case "birthDateMonth":
              case "birthDateYear":
                this.$nextTick(() => {
                    var birthDateDay = getById('birthDateDay');
                    var birthDateMonth = getById('birthDateMonth');
                    var birthDateYear = getById('birthDateYear');

                    // Check that each of the inputs in the date fieldset are validly filled
                    var datewrong = false;
                    var datereg = [
                        /^([0-2][0-9]$|^(3)[0-1])$/, /^(((0)[0-9])$|^((1)[0-2]))$/,
                        /^(19[0-9]{2})$|^(20[0-9]{2})$/
                    ];
                    var fieldinps = [];
                    fieldinps.push(birthDateDay)
                    fieldinps.push(birthDateMonth)
                    fieldinps.push(birthDateYear)
                    for (var i = 0; i < 3; i++) {
                        var zeroPaddedValue = zeroPad(fieldinps[i].value.trim(), 2);
                        if (!(zeroPaddedValue).match(datereg[i]) || zeroPaddedValue == 0o0) { datewrong = true; }
                    }
                    
                    if (birthDateDay.classList.contains('touched') && birthDateMonth.classList.contains('touched') && birthDateYear.classList.contains('touched')) {
                      if (birthDateDay.value == "" && birthDateMonth.value == "" && birthDateYear.value == "") {
                        this.$set(this.errors, 'birthDate', this.mandatoryMessage);
                        this.complete = false;
                        this.$emit('update-errors', this.errors);
                        birthDateDay.classList.remove('complete');
                        birthDateMonth.classList.remove('complete');
                        birthDateYear.classList.remove('complete');
                        formIsInvalid = true;
                      }
                      else if (datewrong) {
                        this.$set(this.errors, 'birthDate', this.invalidMessage);
                        this.complete = false;
                        this.$emit('update-errors', this.errors);
                        birthDateDay.classList.remove('complete');
                        birthDateMonth.classList.remove('complete');
                        birthDateYear.classList.remove('complete');
                        formIsInvalid = true;
                      } else {
                        // Check if the birth date is not in the future and the user is at least 18 years old
                        var day = parseInt(birthDateDay.value.trim(), 10);
                        var month = parseInt(birthDateMonth.value.trim(), 10);
                        var year = parseInt(birthDateYear.value.trim(), 10);
                        var birthDate = new Date(year, month - 1, day);
                        var today = new Date();

                        if (birthDate > today) {
                          this.$set(this.errors, 'birthDate', this.invalidMessage);
                          this.complete = false;
                          this.invalid = true;
                          this.$emit('update-errors', this.errors);
                          birthDateDay.classList.remove('complete');
                          birthDateMonth.classList.remove('complete');
                          birthDateYear.classList.remove('complete');
                          formIsInvalid = true;
                        } else {
                          var age = today.getFullYear() - birthDate.getFullYear();
                          var monthDifference = today.getMonth() - birthDate.getMonth();

                          if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
                            age--;
                          }

                          if (age < 18) {
                            this.$set(this.errors, 'birthDate', 'You must be 18 or over to apply for a credit card');
                            this.complete = false;
                            this.invalid = true;
                            this.$emit('update-errors', this.errors);
                            birthDateDay.classList.remove('complete');
                            birthDateMonth.classList.remove('complete');
                            birthDateYear.classList.remove('complete');
                            formIsInvalid = true;
                          } else {
                            this.$delete(this.errors, 'birthDate');
                            this.$emit('update-errors', this.errors);
                            this.invalid = false;

                            if (birthDateDay.value != "" && birthDateMonth.value != "" && birthDateYear.value != "") {
                              birthDateDay.classList.add('complete');
                              birthDateMonth.classList.add('complete');
                              birthDateYear.classList.add('complete');
                            }
                          }
                        }
                      }
                    }
                  });
                  break;
              
              case "mobilePhoneNumber":
                var mobileRegEx = new RegExp("\^\[0\]\[1\-9\]\\d\{9\}\$\|\^\[1\-9\]\\d\{9\}\$");
                var formattedValue = value.replace(/\s/g, '').replace(/^(\+44)/, '');
                this.localValue = formattedValue;
                if(!formattedValue.match(mobileRegEx)) {
                  this.$set(this.errors, this.id, this.invalidMessage);
                  this.complete = false;
                  this.invalid = true;
                  this.$emit('update-errors', this.errors);
                  formIsInvalid = true;
                  return;
                } else {
                  this.invalid = false;
                }
              break;
              
              case "incomeAmount":
              case "monthlyOutgoings":
              case "otherHouseholdIncome":
              case "creditAmount":
                // Remove commas and dots and validate as number
                var numericValue = value.replace(/[,\.]/g, '');
                
                //if the value is not a number or less than zero then throw the invalid message error
                if (isNaN(numericValue) || numericValue < 0) {
                  this.$set(this.errors, this.id, this.invalidMessage);
                  this.complete = false;
                  this.invalid = true;
                  this.$emit('update-errors', this.errors);
                  formIsInvalid = true;
                  return;
                } else {
                  this.invalid = false;
                }

                if (this.id === "creditAmount") {
                  if (parseInt(numericValue) < 50) {
                    this.$set(this.errors, this.id, "Please enter a balance amount of £50 or more");
                    this.complete = false;
                    this.invalid = true;
                    this.$emit('update-errors', this.errors);
                    formIsInvalid = true;
                  } else if (parseInt(numericValue) > 9999999) {
                    this.$set(this.errors, this.id, "Please enter a balance amount of £9,999,999 or less");
                    this.complete = false;
                    this.invalid = true;
                    this.$emit('update-errors', this.errors);
                    formIsInvalid = true;
                  } else {
                    this.invalid = false;
                  }
                }

                // Format the value with commas
                var formattedValue = parseInt(numericValue).toLocaleString();
                this.localValue = formattedValue;
                break;
              
              case "occupation":
                var nameRegEx = new RegExp("^[a-zA-Z -]*$") //letters, spaces and dashes
                if(!value.match(nameRegEx)) {
                  this.$set(this.errors, this.id, this.invalidMessage);
                  this.complete = false;
                  this.invalid = true;
                  this.$emit('update-errors', this.errors);
                  formIsInvalid = true;
                  return;
                } else {
                  this.invalid = false;
                }
                break;
              
              case "postCodeAuto":
                if(this.postCodeAutoError != "") {
                  var postCodeRegEx = new RegExp("^[A-Z]{1,2}[0-9][0-9A-Z]?[ ]?[0-9][A-Z]{2}$", "i");
                  if(!value.match(postCodeRegEx)) {
                    this.$set(this.errors, this.id, 'Please enter a valid postcode');
                    this.complete = false;
                    this.invalid = true;
                    this.$emit('update-errors', this.errors);
                    return;
                  } else {
                    this.invalid = false;
                  }
                }
                break;

              case "postCode":
                var postCodeRegEx = new RegExp("^[A-Z]{1,2}[0-9][0-9A-Z]?[ ]?[0-9][A-Z]{2}$", "i");
                if(!value.match(postCodeRegEx)) {
                  this.$set(this.errors, this.id, 'Please enter a valid postcode');
                  this.complete = false;
                  this.invalid = true;
                  this.$emit('update-errors', this.errors);
                  return;
                } else {
                  this.invalid = false;
                }
                break;
            }

            // Set complete to true if the input has a value and no errors and is not a date item
            if(!this.isDateItem) {
              if (value !== "" && !this.errors[this.id]) {
                this.complete = true;
                this.invalid = false;
              } else {
                this.complete = false;
              }
            }
          } else {
            //add the commas for currency inputs here so they appear in the input whilst entering, not just after touched (focus-out)
            switch(this.id) {
              case "incomeAmount":
              case "monthlyOutgoings":
              case "otherHouseholdIncome":
              case "creditAmount":
                var numericValue = value.replace(/[,\.]/g, '');
                // Format the value with commas
                if (!isNaN(numericValue) && numericValue !== '') {
                  var formattedValue = parseInt(numericValue).toLocaleString();
                  this.localValue = formattedValue;
                }
                break;
            }
          }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.horizontal {
    display: flex;
    align-items: center;
}
.checknumb {
    display: none;
}
.radio {
    flex-grow: 0;
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    border: 1px solid #252a36;
    border-radius: 50%;
    padding: .6875rem;
    vertical-align: middle;
    position: relative;
    appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    margin: 0;
    margin-right: 1rem;
}
.radio + label {
    cursor: pointer;
    color: #444;
}

.inputgroup.horizontal.checkbox {
    gap: 1rem;
}
.inputgroup.horizontal.checkbox label {
  color: #444;
}
.inputgroup.horizontal.checkbox + .inputgroup.horizontal.checkbox {
    margin-top: 1rem;
}
.inputgroup.horizontal.checkbox input {
    width: 1.5rem;
    height: 1.5rem;
    border: 0.0625rem solid #252a36;
    margin: 0;
    border-radius: .25rem;
    appearance: none;
    box-shadow: none;
    padding: 0.6875rem;
    vertical-align: middle;
    position: relative;
    bottom: 0.0625rem;
    cursor: pointer;
}
.inputgroup.horizontal.checkbox input:checked {
    background-color: white;
    background-image: url("data:image/svg+xml,%3Csvg width='13' height='10' viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.20508 5.13379L4.40346 8.33216L11.3333 1.40234' stroke='%232E1A47' stroke-width='2.13225' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center
}
.inputgroup.horizontal.checkbox label {
    font-weight: normal;
    margin-bottom: 0;
    cursor: pointer;
}

.checknumb:hover + label {
    background-color: #f3f3f3;
    cursor: pointer;
}

.checknumb + label:focus, 
input:not([type="radio"]):focus {
    border-width: 2px;
    border-color: #949494;
    outline: 0px;
}

.inputgroup.horizontal.checkbox input:focus-visible,
.inputgroup.horizontal.checkbox input:active,
.inputgroup.horizontal.checkbox input:focus {
    appearance: none;
    -moz-appearance: none;
    outline: 0.25rem solid #ffd801;
    border: 0.0625rem solid #252a36;
    border-width: 0.125rem;
    margin-right: -0.125rem;
}

.radio:focus-visible,
.radio:active,
.radio:focus {
    appearance: none;
    -moz-appearance: none;
    outline: 0.25rem solid #ffd801;
    border: 0.0625rem solid #252a36;
    border-width: 0.125rem;
    outline-offset: 0;
    margin-right: 0.875rem;
    border-radius: 50%;
    margin-bottom: -0.125rem;
}

.radio:checked {
    background-color: #fff;
    background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><rect width="12" height="12" rx="6" fill="%232E1A47"/></svg>');
    background-repeat: no-repeat;
    background-position: center center;
    border: 0.125rem solid #252a36;
    margin-right: 0.875rem;
    margin-bottom: -0.125rem;
}

.checknumb:checked + label {
    border: 0px;
    color: white;
    background-color: #666666;
}
.checkbin:checked + label:before {
    border-color: #666666;
    background-color: #666666;
}

.checknumb:checked + label:after {
    content: '';
    display: inline-block;
    margin-left: 0.5em;
    width: 1.25em;
    height: 1.25em;
    vertical-align: middle;
}
input[name="residentialStatusCode"]:checked + label {
    width: 10em;
}

.checknumb + label {
    display: inline-block;
    margin: 0.25em 0px;
    padding: 0.75em 1.5em;
    border: 1px solid #c1c1c1;
    border-left: 0px;
    text-align: center;
}
.checknumbf + label {
    border-left: 1px solid #c1c1c1;
    border-top-left-radius: 2em;
    border-bottom-left-radius: 2em;
}
.checknumbl + label {
    border-top-right-radius: 2em;
    border-bottom-right-radius: 2em;
}
.dateitems label {
    font-size: 1rem;
    line-height: 1.3125rem;
    margin-bottom: 0.5rem;
}
input:not([type="radio"]) {
    font-size: 1.125rem;
    font-family: 'Nunito Sans', 'Helvetica', 'Arial', sans-serif;
    border-radius: .25rem;
    height: 3.5rem;
    padding-top: .875rem;
    padding-left: 1rem;
    padding-bottom: .875rem;
    padding-right: 1rem;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: #222;
    line-height: 1.75rem;
    background: none;
    color: #222;
}
input:not([type="radio"]).complete {
    border-bottom-width: 0.125rem;
}
input:not([type="radio"]):focus,
input:not([type="radio"]):focus-within {
    border-radius: 0.25rem;
    border-width: 0.125rem;
    outline: 0.25rem solid #ffd801;
    outline-offset: 0;
    border-color: #252a36;
} 
input[type="radio"] + label, button + label {
    font-weight: normal;
    line-height: normal;
    margin-bottom: 0;
}
label {
    display: block;
    width: fit-content;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.75rem;
    margin-bottom: 0.5rem;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
  appearance: textfield;
}
input.dateinps {
    text-align: center;
    width: 3.6875rem;
    padding: 0.875rem 0.65rem;
}
input.dateinps.year {
    width: 4.75rem;
}
#searchdone {
    display: none;
}
strong {
    display: inline-block;
    width: 1.25em;
}
.nameinps, .emailinp, .occinp {
    max-width: 19.4375rem;
    width: 100%;
}
input.moneyinp {
    max-width: 20.1875rem;
    width: 100%;
    padding-left: 3.6875rem;
}
input.mobileinp {
    max-width: 20.1875rem;
    width: 100%;
    padding-left: 5.0625rem;
}
.prefix-wrap {
    position: relative;
}
.prefix-wrap .prefix {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 100%;
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-right: 1rem;
    padding-left: 1rem;
    background: white;
    border: 0.0625rem solid black;
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
}
.prefix.complete {
  border-bottom: 0.125rem solid;
}
.prefix-wrap.focused .prefix {
    border-radius: 0.25rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-width: 0.125rem;
    border-color: #252a36;
    border-right-width: 0.0625rem;
    padding-left: 0.9375rem;
}
</style>
